module.exports = __webpack_public_path__ + "static/media/denunciation_in_review.0cbbdb29.svg";